(function () {
  const WHITE_LOGO = 'https://cdn.shopify.com/s/files/1/1061/6117/6915/files/TrueBlue_white_615be6ff-8952-4cde-8894-7c2cb76d3016.png?v=1775643928';
  const BLACK_LOGO = 'https://cdn.shopify.com/s/files/1/1061/6117/6915/files/TrueBlue_Black_ff2c2eb3-75dc-455f-933b-faf6c166373a.png?v=1775806385';

  function swapLogo(scrollDirection) {
    const logoImg = document.querySelector('header-component img');
    if (!logoImg) return;
    if (scrollDirection === 'up' || scrollDirection === 'none') {
      logoImg.src = BLACK_LOGO;
    } else {
      logoImg.src = WHITE_LOGO;
    }
  }

  function init() {
    const header = document.querySelector('header-component');
    if (!header) return;
    const observer = new MutationObserver(() => {
      const direction = header.dataset.scrollDirection || 'none';
      swapLogo(direction);
    });
    observer.observe(header, { attributes: true, attributeFilter: ['data-scroll-direction'] });
    swapLogo('none');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
